var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M1.5,10A1.5,1.5,0,0,1,0,8.5v-2a.5.5,0,1,1,1,0v2a.5.5,0,0,0,.5.5h7A.5.5,0,0,0,9,8.5v-2a.5.5,0,1,1,1,0v2A1.5,1.5,0,0,1,8.5,10ZM5,7H4.94l-.011,0h0l-.011,0h0l-.011,0h0l-.009,0h0l-.006,0-.007,0h0a.493.493,0,0,1-.227-.13l-2.5-2.5a.5.5,0,1,1,.707-.707L4.5,5.293V.5a.5.5,0,0,1,1,0V5.293L7.146,3.646a.5.5,0,1,1,.707.707l-2.5,2.5a.494.494,0,0,1-.228.13h0l-.008,0-.006,0h0l-.009,0h0l-.01,0h0l-.011,0h0L5.06,7H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.834ca54d027dab4ff166fc1731392ffb.svg";
export { ForwardRef as ReactComponent };